import removalRequestsList from '@/store/modules/removal-requests/removal-requests-list'
import removalRequestsInfo from '@/store/modules/removal-requests/removal-requests-info'

export default {
  removalRequestsList,
  removalRequestsInfo,
}
